var PatentCopyMoveService_1;
var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import { DetailServiceSymbol } from '@/services/DetailService';
import ptDialogAutoMounterManager from '@/services/PtDialogAutoMounterManager';
import { refreshWithParamsAsQuery } from '@/routers';
import { Toast } from 'patsnap-biz';
import { deletePatentsApi } from '@cores/apis/workspace_api/patents';
import { inject, injectService, provide } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { SpaceService } from '@/domains/detail/space/types/space-service.interface';
import { FolderService } from '@/domains/detail/folder/types/folder-service.interface';
import { useFolderList } from '@/presentation/pages/workspace-detail/composables/folder-list/use-folder-list';
export const PatentCopyMoveServiceSymbol = Symbol('PatentCopyMoveService');
let PatentCopyMoveService = PatentCopyMoveService_1 = class PatentCopyMoveService {
    constructor(pageSelectorService, detailService, spaceService, folderService) {
        this.pageSelectorService = pageSelectorService;
        this.detailService = detailService;
        this.spaceService = spaceService;
        this.folderService = folderService;
        this.dragState = {
            dragPatentHelperEl: null,
            dragMode: '',
            dragData: null,
        };
    }
    static CopyMoveDialog() {
        return import('@/presentation/components/CopyMoveDialog/CopyMoveDialog.vue');
    }
    static MoveConfirmDialog() {
        return import('@/presentation/components/folders/MoveConfirmDialog.vue');
    }
    setPatentDragHelper(el) {
        this.dragState.dragPatentHelperEl = el;
    }
    setPatentDrag(mode, ids) {
        this.dragState.dragMode = mode;
        this.dragState.dragData = ids;
    }
    openMovePatentDialog(mode, selectedCount) {
        ptDialogAutoMounterManager.update(PatentCopyMoveService_1.CopyMoveDialog, {
            mode,
            selectedCount,
            spaceId: this.spaceService.spaceInfo.space_id,
            folderId: this.folderService.folderInfo.folder_id,
            onActionHandler: this.onMoveFinish.bind(this),
            onCloseHandler: () => {
                ptDialogAutoMounterManager.toggleOpenState(PatentCopyMoveService_1.CopyMoveDialog, false);
            },
            onFolderModify: this.onFolderModify.bind(this),
        });
        ptDialogAutoMounterManager.toggleOpenState(PatentCopyMoveService_1.CopyMoveDialog, true);
    }
    onMoveFinish(mode) {
        if (mode === 'move') {
            refreshWithParamsAsQuery();
            this.pageSelectorService.unselectAll();
            // TOC-19799
        }
    }
    onFolderModify(folder) {
        const { getFolderById, updateFolderById, addFolder } = useFolderList();
        if (getFolderById(folder.folder_id)) {
            updateFolderById(folder.folder_id, folder);
        }
        else {
            addFolder(folder.parent_id, folder);
        }
    }
    openMoveConfirmDialog(params, mode = 'move') {
        ptDialogAutoMounterManager.update(PatentCopyMoveService_1.MoveConfirmDialog, {
            mode,
            ...params,
            patents: this.pageSelectorService.selectedIds,
            deSelectPatents: this.pageSelectorService.deselectedIds,
            fromFolder: this.folderService.folderInfo.folder_name,
            spaceId: this.spaceService.spaceInfo.space_id,
            folderId: this.folderService.folderInfo.folder_id,
            onActionHandler: this.onMoveFinish.bind(this),
            onCloseHandler: () => {
                ptDialogAutoMounterManager.toggleOpenState(PatentCopyMoveService_1.MoveConfirmDialog, false);
            },
        });
        ptDialogAutoMounterManager.toggleOpenState(PatentCopyMoveService_1.MoveConfirmDialog, true);
    }
    static DeletePatentsConfirmDialog() {
        return import('@/presentation/components/folders/DeletePatentsConfirm.vue');
    }
    toggleDeletePatentsConfirm(open, params, listeners = {}) {
        if (open) {
            // @ts-ignore todo
            if (!(params && params.onActionHandler)) {
                console.error('onActionHandler is required when open DeletePatentsConfirmDialog');
            }
            ptDialogAutoMounterManager.update(PatentCopyMoveService_1.DeletePatentsConfirmDialog, {
                count: this.pageSelectorService.selectedCount,
                deSelectPatents: this.pageSelectorService.deselectedIds,
                onCloseHandler: () => {
                    ptDialogAutoMounterManager.toggleOpenState(PatentCopyMoveService_1.DeletePatentsConfirmDialog, false);
                },
                ...params,
            }, listeners);
            ptDialogAutoMounterManager.toggleOpenState(PatentCopyMoveService_1.DeletePatentsConfirmDialog, true);
        }
        else {
            ptDialogAutoMounterManager.toggleOpenState(PatentCopyMoveService_1.DeletePatentsConfirmDialog, false);
        }
    }
    setDeletePatentsLoading(isLoading) {
        ptDialogAutoMounterManager.update(PatentCopyMoveService_1.DeletePatentsConfirmDialog, {
            isLoading: isLoading,
        });
    }
    onDeletePatentsSubmit(params) {
        const i18n = injectService(i18nSymbol);
        const workspaceId = this.spaceService.spaceInfo.space_id;
        const folderId = this.folderService.folderInfo.folder_id;
        this.setDeletePatentsLoading(true);
        return deletePatentsApi({
            space_id: workspaceId,
            folder_id: folderId,
            select_mode: this.pageSelectorService.mode,
            patent_ids: this.pageSelectorService.finalIds,
            refiner: params.refiner,
            family_type: params.family_type,
            range_from: this.pageSelectorService.rangeFrom,
            range_to: this.pageSelectorService.rangeTo,
            sort: params.sort,
        })
            .then(() => {
            Toast({
                type: 'success',
                message: i18n.t('workspace.taskCenter.deleteTaskTip'),
                dangerouslyUseHTMLString: true,
                showClose: true,
                duration: 5000,
            });
            // 关闭窗口
            this.toggleDeletePatentsConfirm(false);
            refreshWithParamsAsQuery();
            this.pageSelectorService.unselectAll();
            this.setDeletePatentsLoading(false);
        })
            .catch((error) => {
            this.setDeletePatentsLoading(false);
            Toast({
                type: 'error',
                message: error._error_msg,
                showClose: true,
                duration: 5000,
            });
        });
    }
};
PatentCopyMoveService = PatentCopyMoveService_1 = __decorate([
    provide(PatentCopyMoveServiceSymbol),
    __param(0, inject(PageSelectorServiceSymbol)),
    __param(1, inject(DetailServiceSymbol)),
    __param(2, inject(SpaceService)),
    __param(3, inject(FolderService)),
    __metadata("design:paramtypes", [Object, Object, typeof (_a = typeof SpaceService !== "undefined" && SpaceService) === "function" ? _a : Object, typeof (_b = typeof FolderService !== "undefined" && FolderService) === "function" ? _b : Object])
], PatentCopyMoveService);
export { PatentCopyMoveService };
